<template>
  <div>
    <div :id="editorId"></div>
  </div>
</template>

<script>
import Weditor from 'wangeditor'

export default {
  name: 'editor',
  props: {
    editorId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editor: ''
    }
  },
  mounted() {
    this.editor = new Weditor(`#${this.editorId}`)
    this.editor.create()
  },
  methods: {
    getHtml() {
      return this.editor.txt.html()
    },
    getText() {
      return this.editor.txt.text()
    },
    setHtml(content) {
      this.editor.txt.html(content)
    },
    clearContent() {
      this.editor.txt.clear()
    }
  }
}
</script>

<style lang="less" scoped>

</style>
